<script>
    import dbData from "../../Stores/utilityDBStore.js";
    import { dateTextforTimeMS, itemUrlForKey } from "../../scripts/wpn2Model.js";

    const apiUrl = process.env.VITE_API_URL;
    export let imageItems;
    let slideIndex = 0;

    showSlides();

    function showSlides() {
        var slides = document.getElementsByClassName("mySlides");
        slideIndex = Math.max(0, slideIndex);
        slideIndex = Math.min(slideIndex, slides.length - 1);
        [...slides].forEach((x) => {
            x.style.display = "none";
        });
        if (slides.length > 0) {
            slides[slideIndex].style.display = "block";
            if (slides.length > 1) {
                var dots = document.getElementsByClassName("dot");
                [...dots].forEach((x) => {
                    x.className = x.className.replace(" active", "");
                });
                dots[slideIndex].className += " active";
            }
        }
    }

    function plusSlides(n) {
        slideIndex += n;
        showSlides();
    }

    function currentSlide(n) {
        slideIndex = n;
        showSlides();
    }
</script>

<div id="slides-box">
    {#each imageItems as item}
        <div id=slide-view class="fade">
            <img
                src={itemUrlForKey('image', item, $dbData.wpn_id, apiUrl)}
                alt="WPN2 camera shot"
                class="img-photo"
            />
            <div class="image-date">{dateTextforTimeMS(item.last_updated)}</div>
        </div>
    {/each}
</div>
{#if imageItems.length > 2}
    <div id="dots-box">
        <div class="image-dots">
            <a href={"#"} class="prev" on:click={() => plusSlides(-1)}>&#10094;</a>
            {#each imageItems as image, index}
                <span class="dot" on:click={() => currentSlide(index)} />
            {/each}
            <a href={"#"} class="next" on:click={() => plusSlides(1)}>&#10095;</a>
        </div>
    </div>
{/if}

<style>
    #slides-box {
        display: flex;
    }
    #slide-view {
        flex: 1;
    }
    .img-photo {
        width: 90%;
    }
    .image-date {
        margin: 4px 0 8px 0;
    }
    .prev,
    .next {
        cursor: pointer;
        padding: 16px;
        font-size: 18px;
        transition: 0.6s ease;
        border-radius: 0 3px 3px 0;
        user-select: none;
    }
    .next {
        right: 0;
        border-radius: 3px 0 0 3px;
    }
    .prev:hover,
    .next:hover {
        background-color: rgba(240, 240, 240, 0.8);
    }
    .image-dots {
        text-align: center;
        margin: 4px 0 8px 0;
    }
    .dot {
        cursor: pointer;
        height: 15px;
        width: 15px;
        margin: 0 2px;
        background-color: #bbb;
        border-radius: 50%;
        display: inline-block;
        transition: background-color 0.6s ease;
    }
    .dot:hover {
        background-color: #717171;
    }
    .fade {
        -webkit-animation-name: fade;
        -webkit-animation-duration: 1.5s;
        animation-name: fade;
        animation-duration: 1.5s;
    }
    @-webkit-keyframes fade {
        from {
            opacity: 0.4;
        }
        to {
            opacity: 1;
        }
    }
    @keyframes fade {
        from {
            opacity: 0.4;
        }
        to {
            opacity: 1;
        }
    }
</style>  